<!-- SecurityAnalysis.vue -->
<template>
    <div class="min-vh-100 text-light p-4">
        <div class="container">
            <!-- Header -->
            <div class="row mb-4">
                <div class="col-12">
                    <div
                        class="d-flex justify-content-between align-items-center"
                    >
                        <div class="d-flex align-items-center">
                            <i
                                class="fas fa-shield-alt text-success fa-2x mr-2"
                            ></i>
                            <div>
                                <h1 class="h4 mb-0">Analyzing ...</h1>
                               <!--  <small class="text-success"
                                    >RUNTIME_ID: {{ sessionId }}</small
                                > -->
                            </div>
                        </div>
                        <div class="text-right">
                            <div class="h4 text-success mb-0">
                                {{ securityScore.toFixed(1) }}%
                            </div>
                            <!-- <small class="text-success">SECURITY_SCORE</small> -->
                        </div>
                    </div>
                </div>
            </div>

            <!-- Progress Bar -->
            <div class="row mb-4">
                <div class="col-12">
                    <div class="position-relative">
                        <div class="progress bg-secondary" style="height: 8px">
                            <div
                                class="progress-bar progress-bar-striped progress-bar-animated bg-success"
                                :style="{ width: `${totalProgress}%` }"
                            ></div>
                        </div>
                        <div
                            class="scan-line"
                            :style="{ left: scanPosition + '%' }"
                        ></div>
                    </div>
                    <div class="d-flex justify-content-between mt-2">
                        <small class="text-muted">{{ steps[0].label }}</small>
                        <small class="text-muted">{{ steps[1].label }}</small>
                        <small class="text-muted">{{ steps[2].label }}</small>
                        <small class="text-muted">{{ steps[3].label }}</small>
                        <!-- <small class="text-muted">{{
                            steps[Math.floor(steps.length / 2)].label
                        }}</small> -->
                        <!-- <small class="text-muted">{{
                            steps[steps.length - 1].label
                        }}</small> -->
                    </div>
                </div>
            </div>

            <!-- Steps -->
            <div class="row">
                <div class="col-12">
                    <div
                        v-for="(step, index) in steps"
                        :key="index"
                        class="mb-3 security-step"
                        :class="{
                            active: currentStep === index,
                            completed: currentStep > index,
                        }"
                    >
                        <div
                            class="card custom-bg-opacity border"
                            :class="getCardClass(index)"
                        >
                            <div class="card-body">
                                <div class="d-flex">
                                    <div class="step-icon">
                                        <i
                                            :class="getIconClass(step, index)"
                                            class="fa-lg"
                                        ></i>
                                    </div>
                                    <div class="ml-3 flex-grow-1">
                                        <div
                                            class="d-flex justify-content-between"
                                        >
                                            <div>
                                                <h5
                                                    class="text-monospace text-success mb-1 text-uppercase"
                                                >
                                                    {{ step.label }}
                                                </h5>
                                            </div>
                                            <div>
                                                <i
                                                    v-if="currentStep > index"
                                                    class="fas fa-check-circle text-success"
                                                ></i>
                                                <i
                                                    v-if="currentStep === index"
                                                    class="fas fa-spinner fa-spin text-muted"
                                                ></i>
                                            </div>
                                        </div>

                                        <div
                                            v-if="currentStep >= index"
                                            class="row mt-3"
                                        >
                                            <div
                                                v-for="(
                                                    metric, mIndex
                                                ) in step.metrics"
                                                :key="mIndex"
                                                :class="[
                                                    'col-12 col-sm-12 col-md-4 mb-2',
                                                    { 'col-lg-3': index === 3 }
                                                ]"
                                            >
                                                <small
                                                    class="text-monospace"
                                                    :class="
                                                        currentStep > index
                                                            ? 'text-success'
                                                            : 'text-muted'
                                                    "
                                                >
                                                    {{ metric.label }}
                                                    <i
                                                        v-if="
                                                            currentStep > index
                                                        "
                                                        class="fas fa-check-circle text-success"
                                                    ></i>
                                                    <i
                                                        v-else
                                                        class="fas fa-spinner fa-spin text-muted"
                                                    ></i>
                                                </small>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "SecurityAnalysis",
    props: {
        isLoadingComplete: {
            type: Boolean,
            default: false,
        },
    },
    emits: ["analysisCompleted"],

    watch: {
        isLoadingComplete(newValue) {
            if (newValue && this.currentStep === this.steps.length - 1) {
                this.completeLastStep();
            }
        },
    },
    data() {
        return {
            displayStartTime: null,
            minimumDisplayTime: 14000, // 10.5s + 3.5s pour la dernière étape
            executionComplete: false,
            currentStep: 0,
            stepProgress: 0, // Progress within current step
            scanPosition: 0,
            securityScore: 0,
            sessionId: Math.random()
                .toString(16)
                .substring(2, 10)
                .toUpperCase(),
            //stepDuration: 3500, // Duration for each step in ms
            stepDuration: 3500, // Duration for each step in ms
            steps: [
                {
                    label: "Step One",
                    //subLabel: "0x7F2A19B :: TLS_AES_256_GCM_SHA384",
                    icon: "shield-alt",
                    metrics: [
                        { label: "Name" },
                        { label: "Email" },
                        {
                            label: "Phone",
                        },
                    ],
                },
                {
                    label: "Step two",
                    // subLabel: "0x8C3D2F4 :: THREAT_DETECTION_ACTIVE",
                    icon: "search",
                    metrics: [
                        { label: "Name", value: "Deep Learning" },
                        { label: "Email", value: "Updated" },
                        { label: "Phone", value: "Analyzing..." },
                    ],
                },
                {
                    label: "Step three",
                    //subLabel: "0x9E4F7A2 :: BEHAVIOR_ANALYSIS",
                    icon: "fingerprint",
                    metrics: [
                        { label: "Name", value: "Deep Learning" },
                        { label: "Email", value: "Updated" },
                        { label: "Phone", value: "Analyzing..." },
                    ],
                },
                {
                    label: "Score Calculation",
                    icon: "check-circle",
                    metrics: [
                        { label: "Email Score", value: "100/100" },
                        { label: "Phone Score", value: "Premium" },
                        {
                            label: "Bot/Human Detection Score",
                            value: "Generated",
                        },
                        { label: "Activity Score", value: "Generated" },
                    ],
                },
            ],
        };
    },
    computed: {
        totalProgress() {
            // Calculate total progress based on current step and progress within step
            const stepsCompleted = this.currentStep;
            const progressPerStep = 100 / this.steps.length;
            return Math.min(
                stepsCompleted * progressPerStep +
                    (this.stepProgress * progressPerStep) / 100,
                100
            );
        },
    },
    methods: {
        completeLastStep() {
            this.stepProgress = 100;
            this.currentStep++;
        },
        getCardClass(index) {
            if (this.currentStep === index) return "border-primary";
            if (this.currentStep > index) return "border-success";
            return "border-secondary";
        },
        getIconClass(step, index) {
            return {
                [`fas fa-${step.icon}`]: true,
                "text-success": this.currentStep > index,
                "text-primary": this.currentStep === index,
                "text-muted": this.currentStep < index,
            };
        },
        startAnalysis() {
            const progressInterval = 20;
            const progressIncrement =
                (100 * progressInterval) / this.stepDuration;

            const progressTimer = setInterval(() => {
                if (this.currentStep >= this.steps.length) {
                    clearInterval(progressTimer);
                    this.$emit("analysisCompleted"); // Émettre l'événement ici
                    return;
                }

                // Pour les 3 premières étapes
                if (this.currentStep < 3) {
                    this.stepProgress += progressIncrement;
                    this.securityScore = this.totalProgress;

                    if (this.stepProgress >= 100) {
                        this.stepProgress = 0;
                        this.currentStep++;
                    }
                } else if (this.currentStep === 3 && this.isLoadingComplete) {
                    this.stepProgress += progressIncrement;
                    // Mettre à jour les deux scores
                    this.securityScore = 75 + (this.stepProgress / 100) * 25;

                    if (this.stepProgress >= 100) {
                        this.currentStep++;
                    }
                }
            }, progressInterval);

            const scanTimer = setInterval(() => {
                this.scanPosition =
                    this.scanPosition >= 100 ? 0 : this.scanPosition + 1;
            }, 30);

            this.$once("hook:beforeDestroy", () => {
                [progressTimer, scanTimer].forEach(clearInterval);
            });
        },
    },
    mounted() {
        this.startAnalysis();
    },
};
</script>

<style scoped>
.security-step {
    transition: all 0.3s ease;
}

.security-step.active {
    transform: translateX(8px) scale(1.02);
}

.step-icon {
    width: 24px;
    text-align: center;
}

.scan-line {
    position: absolute;
    top: 0;
    height: 100%;
    width: 80px;
    background: linear-gradient(
        90deg,
        transparent,
        rgba(255, 255, 255, 0.2),
        transparent
    );
    transform: skewX(-45deg);
    transition: left 0.1s linear;
}

.card {
    transition: all 0.3s ease;
}

.card.border-primary {
    box-shadow: 0 0 15px rgba(0, 123, 255, 0.1);
}

.card.border-success {
    opacity: 0.8;
}

.progress-bar {
    background-image: linear-gradient(
        45deg,
        rgba(255, 255, 255, 0.15) 25%,
        transparent 25%,
        transparent 50%,
        rgba(255, 255, 255, 0.15) 50%,
        rgba(255, 255, 255, 0.15) 75%,
        transparent 75%,
        transparent
    );
    background-size: 1rem 1rem;
}

.custom-bg-opacity {
    background-color: rgba(0, 0, 0, 0.2); /* Le 0.5 définit l'opacité */
}
</style>
